import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

const MENUTOP = [
  {
    state: 'apps',
    substate:'media',
    name: 'MEDIA',
    type: 'top',
    icon: 'dashboard'
  },
  {
    state: 'maps',
    substate:'google',
    name: 'GOOGLE',
    type: 'top',
    icon: 'navigation'
  },
  {
    state: 'apps',
    substate:'social',
    name: 'ACCOUNT',
    type: 'top',
    icon: 'settings'
  }
];

const MENUITEMS = [
  {
    state: 'apps',
    substate:'users',
    name: 'USERS',
    type: 'mainlink',
    icon: 'supervisor_account'
  },
  {
    state: 'maps',
    substate:'google',
    name: 'GOOGLE',
    type: 'mainlink',
    icon: 'navigation'
  },
  {
    state: 'taskboard',
    name: 'TASKBOARD',
    type: 'link',
    icon: 'view_column',
  }];

@Injectable()
export class GtMenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }
  getTop(): Menu[] {
    return MENUTOP;
  }
  add(menu: Menu) {
    MENUITEMS.push(menu);
  }
}
/*
  {
    state: 'forms',
    substate:'upload',
    name: 'UPLOAD',
    type: 'top',
    icon: 'cloud_upload'
  }
*/


// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/shared/menu-items/gt-menu-items.ts